/* ════════════════════════════════════════════════════════════════
 * POD Extras Item — Self-contained interaction layer
 * Mounts ONLY inside [data-pod-extras-step].
 * Completely isolated from main-pod-wizard.js (no global state).
 *
 * Public API (read-only, for main wizard to integrate):
 *   window.POD_EXTRAS_STATE  — { selectedExtras: [...], totalCents: N }
 *   CustomEvent('pod-extras:change')  — fires on any toggle
 * ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__POD_EXTRAS_ITEM_INIT__) return;
  window.__POD_EXTRAS_ITEM_INIT__ = true;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    var code = (currency || 'USD').toUpperCase();
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initStep(stepEl) {
    var configEl = stepEl.querySelector('[data-pod-extras-config]');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); }
    catch (e) { console.warn('[pod-extras-item] Invalid config JSON', e); return; }

    var state = {
      productId: config.productId,
      currency: config.currency,
      basePriceCents: config.basePriceCents || 0,
      // 注: 包邮阈值已在 [v1.4] 中改为单一来源 (settings.free_shipping_threshold),
      // 通过 DOM attribute data-pod-shipping-threshold 读取, 此处不再存字面量.
      freeShippingThreshold: 0,
      selectedExtras: [],
      totalCents: config.basePriceCents || 0,
      hasRush: false
    };

    var items = $$('[data-pod-extra-item]', stepEl);
    items.forEach(function (item) {
      if (item.classList.contains('is-checked')) {
        var priceCents = parseInt(item.getAttribute('data-extra-price-cents') || '0', 10);
        var originalPriceCents = parseInt(item.getAttribute('data-variant-price') || '0', 10);
        var isRush = item.getAttribute('data-extra-is-rush') === 'true';
        state.selectedExtras.push({
          blockId: item.getAttribute('data-block-id'),
          productId: item.getAttribute('data-extra-product-id'),
          variantId: item.getAttribute('data-extra-variant-id'),
          priceCents: priceCents,
          originalPriceCents: originalPriceCents,
          isFreeGift: item.getAttribute('data-extra-is-free') === 'true',
          isRush: isRush
        });
        if (isRush) state.hasRush = true;
      }
    });
    recomputeTotal(stepEl, state);

    stepEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pod-extra-toggle]');
      if (!btn) return;
      var item = btn.closest('[data-pod-extra-item]');
      if (!item) return;
      e.preventDefault();
      toggleItem(stepEl, state, item);
    });

    items.forEach(function (item) {
      var btn = item.querySelector('[data-pod-extra-toggle]');
      if (!btn) return;
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggleItem(stepEl, state, item);
        }
      });
    });
    // Listen for variant changes from main wizard (user switches product options)
    document.addEventListener('pod-variant:change', function (e) {
      if (!e.detail || !e.detail.priceCents) return;
      state.basePriceCents = e.detail.priceCents;
      recomputeTotal(stepEl, state);
      updatePricebar(state);
    });

    // [v1.4] 安装全局 cart:updated 监听 (仅一次, 多实例隔离)
    installCartUpdateListener(state);
  }

  function toggleItem(stepEl, state, item) {
    var btn = item.querySelector('[data-pod-extra-toggle]');
    var blockId = item.getAttribute('data-block-id');
    var productId = item.getAttribute('data-extra-product-id');
    var variantId = item.getAttribute('data-extra-variant-id');
    var priceCents = parseInt(item.getAttribute('data-extra-price-cents') || '0', 10);
    var originalPriceCents = parseInt(item.getAttribute('data-variant-price') || '0', 10);
    var isFreeGift = item.getAttribute('data-extra-is-free') === 'true';
    var isRush = item.getAttribute('data-extra-is-rush') === 'true';

    var isChecked = item.classList.toggle('is-checked');
    btn.setAttribute('aria-pressed', isChecked ? 'true' : 'false');

    if (isChecked) {
      // 检查：如果配置了免费/价格覆盖，但隐藏商品在 Shopify 后台价格不是 $0，给出警告
      var variantPriceEl = item.querySelector('[data-variant-price]');
      var variantPriceCents = variantPriceEl ? parseInt(variantPriceEl.getAttribute('data-variant-price'), 10) : 0;

      if ((isFreeGift || priceCents === 0) && variantPriceCents > 0) {
        // 用户设置了 FREE，但 Shopify 后台的 variant 价格不是 $0
        console.warn('[pod-extras] Warning: Extra "' + blockId + '" is configured as FREE, but the variant price in Shopify is not $0. The cart will use the variant price. To fix, set the hidden product price to $0 in Shopify Admin.');
        // 显示提示给用户
        var priceHint = item.querySelector('.pod-extras-item__price-hint');
        if (priceHint) {
          priceHint.textContent = '⚠️ Shopify价格未设为$0，会按原始价格添加';
          priceHint.style.color = '#e74c3c';
        }
      }

      state.selectedExtras.push({
        blockId: blockId,
        productId: productId,
        variantId: variantId,
        priceCents: priceCents,
        originalPriceCents: originalPriceCents,
        isFreeGift: isFreeGift,
        isRush: isRush
      });
      if (isRush) state.hasRush = true;
    } else {
      state.selectedExtras = state.selectedExtras.filter(function (x) {
        return x.blockId !== blockId;
      });
      // 重新计算 hasRush
      state.hasRush = state.selectedExtras.some(function(x) { return x.isRush === true; });
    }

    recomputeTotal(stepEl, state);

    // Expose state globally
    window.POD_EXTRAS_STATE = state;

    // Dispatch custom event for main wizard to listen
    stepEl.dispatchEvent(new CustomEvent('pod-extras:change', {
      bubbles: true,
      detail: { state: state, changedBlockId: blockId, isChecked: isChecked }
    }));

    // Update the right-side pricebar immediately
    updatePricebar(state);
  }

  function recomputeTotal(stepEl, state) {
    var extraSum = state.selectedExtras.reduce(function (sum, x) {
      return sum + (x.priceCents || 0);
    }, 0);
    state.totalCents = state.basePriceCents + extraSum;

    // [v1.4.1] Free shipping bar — Shopify Dawn 官方推荐做法 (变体切换时乐观更新):
    // 关键洞察: 用户切换 variant 时 (如选了 $50 的 variant, 还没 add-to-cart),
    // 进度条必须**立刻**显示反映新 variant 的状态.
    //   - 真实 cart.total_price = 用户**已加进购物车**的所有商品总价
    //   - state.totalCents = 当前 wizard 选择的 basePrice + extras (用户意图)
    //   - 乐观总值 = cart_total + (state.totalCents - 已加入购物车的本商品价格)
    //
    // 实现: 用 cart_total + state.totalCents 作为乐观分母 (二者取 max
    // 保证 "用户已选好但没加" 的金额被反映). 副作用: 若用户已加本商品到购物车
    // 然后切换 variant, 旧 variant 价格已被 cart 计入, 新 variant 价格又通过
    // state.totalCents 计入, 会**暂时**重复, 但 cart:updated 事件随后会用真实
    // /cart.js 覆盖, 最终一致.
    updateShippingBarFromCart(stepEl, state, state.totalCents);
  }

  /**
   * 读取 DOM 阈值 + 当前购物车总价, 刷新包邮进度条与文本.
   * @param stepEl         Extras step 根元素
   * @param state          本地状态 (currency / basePriceCents / selectedExtras)
   * @param cartTotalCents 实际用于比较的金额 (cents). 若未传, 用 Liquid 初次渲染的 data-pod-cart-total.
   *                        recomputeTotal 会传 state.totalCents 作为乐观值, 反映用户当前 variant 意图.
   */
  function updateShippingBarFromCart(stepEl, state, cartTotalCents) {
    var wizardRoot = stepEl.closest('[data-pod-wizard]');
    var scope = wizardRoot || document;
    var bar = scope.querySelector('[data-pod-extras-shipping]');
    if (!bar) {
      if (window.console && console.debug) {
        console.debug('[pod-extras-item] shipping bar elements not yet in DOM; will retry on next update');
      }
      return;
    }
    // 作用域守卫: Bundle 商品页的进度条由 assets/bundle-customizer.js 独占控制.
    // Bundle 根节点是 #BundleWizard (不是 [data-pod-wizard]), 本脚本因全局加载而
    // 误挂载到该页的 Extras step 上; 若继续写入, 会用 product.price 作为基准价
    // 覆盖 bundle 页刚渲染好的值, 造成进度条先跑满后收缩. 此处主动让出控制权.
    if (bar.closest('#BundleWizard')) {
      if (window.console && console.debug) {
        console.debug('[pod-extras-item] shipping bar owned by bundle-customizer.js; skipping');
      }
      return;
    }
    var fillEl = bar.querySelector('[data-pod-extras-shipping-fill]');
    var textEl = bar.querySelector('[data-pod-extras-shipping-text]');
    if (!fillEl || !textEl) return;

    // 阈值永远从 DOM 读, JS 永不存数字字面量
    var threshold = parseInt(bar.getAttribute('data-pod-shipping-threshold'), 10) || 0;
    // 若调用方未传 cartTotalCents, 用服务端初次渲染的 data-pod-cart-total (真实购物车总价)
    if (typeof cartTotalCents !== 'number') {
      var serverCart = parseInt(bar.getAttribute('data-pod-cart-total'), 10);
      cartTotalCents = isNaN(serverCart) ? 0 : serverCart;
    }

    if (threshold <= 0) return; // settings 关闭时

    var pct = (cartTotalCents / threshold) * 100;
    pct = Math.max(0, Math.min(100, pct));
    fillEl.style.width = pct + '%';

    var barProgress = bar.querySelector('.pod-extras-shipping__bar');
    if (barProgress) {
      barProgress.setAttribute('aria-valuenow', Math.round(pct));
    }

    if (cartTotalCents >= threshold) {
      textEl.innerHTML = "You've qualified for <strong>FREE shipping</strong>.";
    } else {
      var remain = threshold - cartTotalCents;
      var formatted = formatMoney(remain, state.currency);
      textEl.innerHTML =
        "You're <strong data-pod-shipping-remaining>" + formatted + "</strong> away from FREE shipping.";
    }

    // 把最新 cartTotal 也回写到 DOM attribute, 让后续刷新可读到.
    // cart:updated 事件会用真实 /cart.js 覆盖这个值, 保证数据源唯一.
    bar.setAttribute('data-pod-cart-total', String(cartTotalCents));
  }

  /**
   * 标准 Shopify 购物车更新事件探测.
   * Dawn / Horizon 都派发 cart:updated (Dawn 也兼容旧版 cart-update).
   * 监听全局一次, 任意 Extras step 都能复用.
   */
  function installCartUpdateListener(state) {
    if (window.__POD_EXTRAS_LISTENER_INSTALLED__) return;
    window.__POD_EXTRAS_LISTENER_INSTALLED__ = true;

    function refetch() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart) return;
          var total = (cart.total_price || 0);
          var currency = (cart.currency && cart.currency.iso_code) || state.currency;
          state.currency = currency;
          // 重新计算 user-visible 总价 (state.totalCents 是 basePrice + extras)
          // 进度条展示的是 cart 总价, 与 state.totalCents 解耦
          var stepEl = document.querySelector('[data-pod-extras-step]');
          if (stepEl) updateShippingBarFromCart(stepEl, state, total);
          // 同步右下方 pricebar (Total) — 跟随购物车真实总价
          var pricebarEls = $$('[data-pod-total-price]');
          pricebarEls.forEach(function (el) {
            el.textContent = formatMoney(total, currency);
          });
        })
        .catch(function (err) {
          if (window.console && console.warn) {
            console.warn('[pod-extras-item] /cart.js fetch failed', err);
          }
        });
    }

    // Dawn / Horizon 标准事件
    document.addEventListener('cart:updated', refetch);
    // 兼容 Dawn 旧版事件
    document.addEventListener('cart-update', function (event) {
      if (event && event.detail && event.detail.cart) {
        var cart = event.detail.cart;
        var total = (cart.total_price || 0);
        var currency = (cart.currency && cart.currency.iso_code) || state.currency;
        state.currency = currency;
        var stepEl = document.querySelector('[data-pod-extras-step]');
        if (stepEl) updateShippingBarFromCart(stepEl, state, total);
        var pricebarEls = $$('[data-pod-total-price]');
        pricebarEls.forEach(function (el) {
          el.textContent = formatMoney(total, currency);
        });
      }
    });
  }

  function updatePricebar(state) {
    // 触发一个自定义事件，让 main-pod-wizard.js 统一处理主商品+附加商品的价格渲染
    document.dispatchEvent(new CustomEvent('pod-pricebar:needs-render', {
       detail: { state: state }
    }));
  }

  function boot() {
    var steps = $$('[data-pod-extras-step]');
    steps.forEach(initStep);

    if (!window.POD_EXTRAS_STATE) {
      window.POD_EXTRAS_STATE = { selectedExtras: [], totalCents: 0 };
    }

    // Sync pricebar on page load with any pre-checked extras
    var firstStep = $('[data-pod-extras-step]');
    if (firstStep && window.POD_EXTRAS_STATE.totalCents > 0) {
      updatePricebar(window.POD_EXTRAS_STATE);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () {
      var steps = $$('[data-pod-extras-step]', e.target);
      steps.forEach(initStep);
    }, 50);
  });
})();
